<div class="indicator" [ngClass]="{active: isActive}">
    <div class="indicator-number">{{ number }}</div>
    <span title="{{text}}">{{ text }}</span>
</div>